<template>
    <div class="row">
        <div class="col-sm-12">
            <form autocomplete="off"
                method="post"
                data-vv-scope="form"
                @keyup.enter="() => {}"
                @submit.prevent="onBeforeSaveItem">
                <div class="row mb-3">
                    <div class="col-sm-auto">
                        <h1 class="content-title">{{ titleItem }}</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-9">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                type="text"
                                class="city-form-group city-bg"
                                id="input-name"
                                name="name"
                                v-model.trim="form.name"
                                v-validate="'required|min:3'"
                                :inputClasses="[{'is-invalid': fnHasError('name') }]"
                                :error="fnFirstError('name')">
                                {{ $t(`${pageID}.model.name`) }}
                            </MaterialInput>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-status"
                                name="status"
                                label="name"
                                :filterable="true"
                                :options="lists.onoff"
                                v-model.trim="form.status"
                                :reduce="option => option.code"
                                v-validate="'required'"
                                :inputClasses="[{'is-invalid': fnHasError('status') }]"
                                :error=" fnFirstError('status')">
                                {{ $t(`${pageID}.model.status`) }}
                            </MaterialSelect>
                        </div>
                    </div>

                    <div class="col-sm-5">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-behavior"
                                name="behavior"
                                label="name"
                                :filterable="true"
                                :options="lists.behaviors"
                                v-model.trim="form.behavior"
                                :reduce="option => option.code"
                                v-validate="'required'"
                                :inputClasses="[{'is-invalid': fnHasError('behavior') }]"
                                :error="fnFirstError('behavior')">
                                {{ $t(`${pageID}.model.behavior`) }}
                            </MaterialSelect>
                        </div>
                    </div>
                    <div class="col-sm-4 col-xl-5">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-apikey"
                                name="apikey"
                                v-model.trim="form.apikey"
                                v-validate="''"
                                :inputClasses="[{'is-invalid': fnHasError('apikey') }]"
                                :error="fnFirstError('apikey')">
                                {{ $t(`${pageID}.model.apikey`) }}
                            </MaterialInput>
                        </div>
                    </div>
                    <div class="col-sm-3 col-xl-2">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-visible"
                                name="visible"
                                label="name"
                                :filterable="true"
                                :options="lists.onoff"
                                v-model.trim="form.visible"
                                :reduce="option => option.bool"
                                v-validate="'required'"
                                :inputClasses="[{'is-invalid': fnHasError('visible') }]"
                                :error="fnFirstError('visible')">
                                {{ $t(`${pageID}.model.visible`) }}
                            </MaterialSelect>
                        </div>
                    </div>

                    <div class="col-sm-3">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                type="number"
                                class="city-form-group city-bg"
                                id="input-minzoom"
                                name="minzoom"
                                v-model.trim="form.minzoom"
                                v-validate="'integer|min_value:0'"
                                :inputClasses="[{'is-invalid': fnHasError('minzoom') }]"
                                :error="fnFirstError('minzoom')">
                                {{ $t(`${pageID}.model.minzoom`) }}
                            </MaterialInput>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                type="number"
                                class="city-form-group city-bg"
                                id="input-maxzoom"
                                name="maxzoom"
                                v-model.trim="form.maxzoom"
                                v-validate="'integer|min_value:0'"
                                :inputClasses="[{'is-invalid': fnHasError('maxzoom') }]"
                                :error="fnFirstError('maxzoom')">
                                {{ $t(`${pageID}.model.maxzoom`) }}
                            </MaterialInput>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                type="number"
                                :step="0.1"
                                :max="1"
                                :min="0"
                                class="city-form-group city-bg"
                                id="input-opacity"
                                name="opacity"
                                v-model.trim="form.opacity"
                                v-validate="{required: true, regex:/^(0(\.\d{1})?|1(\.0+)?)$/}"
                                :inputClasses="[{'is-invalid': fnHasError('opacity') }]"
                                :error="fnFirstError('opacity')">
                                {{ $t(`${pageID}.model.opacity`) }}
                            </MaterialInput>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                type="number"
                                class="city-form-group city-bg"
                                id="input-order"
                                name="order"
                                v-model.trim="form.order"
                                v-validate="'required|integer|min_value:1'"
                                :inputClasses="[{'is-invalid': fnHasError('order') }]"
                                :error="fnFirstError('order')">
                                {{ $t(`${pageID}.model.order`) }}
                            </MaterialInput>
                        </div>
                    </div>

                </div>

                <div class="row">
                    <div class="col-12 col-sm-9">
                        <div class="form-group">
                            <label class="city-label">{{ $t(`${pageID}.model.attribution`) }}</label>
                            <template v-if="readonlyFormItem">
                                <div v-html="form.attribution"></div>
                            </template>
                            <template v-else>
                                <div class="city-form-group" :class="{'is-invalid': fnHasError('attribution') }">
                                    <ckeditor
                                        name="attribution"
                                        v-model="form.attribution"
                                        :disabled="readonlyFormItem"
                                        :editor="cKEditor.editor"
                                        :config="cKEditor.editorConfig"
                                        v-validate="''"
                                    />
                                    <small v-if="fnFirstError('attribution')" class="d-block invalid-feedback">{{ fnFirstError('attribution') }}</small>
                                    <HelpSpan :helpText="`${pageID}.help.attribution`" />
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="d-flex flex-column h-100 pb-3 image-container">
                            <label class="city-label">{{ $t(`${pageID}.model.img`) }}</label>
                            <UploadSingleImage
                                :disabled="readonlyFormItem"
                                v-model="form.img"
                                imageClass="background-contain"
                                name="img"
                                v-validate="{required: isBase}">
                            </UploadSingleImage>
                            <small v-if="fnFirstError('img')" class="d-block invalid-feedback">{{ fnFirstError('img') }}</small>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <MaterialInput
                            :readonly="true"
                            :disabled="true"
                            class="city-form-group city-bg"
                            id="input-layer"
                            name="layer"
                            v-model="layerName"
                            v-validate="'required'"
                            :inputClasses="[{'is-invalid': fnHasError('layer') }]"
                            :error="fnFirstError('layer')">
                            {{ $t(`${pageID}.model.layer`) }}

                            <template v-slot:grpAppend>
                                <button
                                    v-if="!readonlyFormItem"
                                    :disabled="readonlyFormItem"
                                    type="button"
                                    class="btn btn-secondary-main btn-sm min-w-auto"
                                    :title="$t(`${pageID}.basemap.buttons.gallery.title`)"
                                    data-toggle="tooltip-city"
                                    @click.prevent="onShowBasemapGallery">
                                    <i class="fas fa-images"></i>&nbsp;{{ $t(`${pageID}.basemap.buttons.gallery.name`) }}
                                </button>
                                <button
                                    v-if="!readonlyFormItem"
                                    :disabled="readonlyFormItem"
                                    type="button"
                                    class="btn btn-secondary-main btn-sm min-w-auto"
                                    :title="$t(`${pageID}.basemap.buttons.ogc.title`)"
                                    data-toggle="tooltip-city"
                                    @click.prevent="onShowBasemapOgc">
                                    <i class="fas fa-earth-americas"></i>&nbsp;{{ $t(`${pageID}.basemap.buttons.ogc.name`) }}
                                </button>
                                <button
                                    v-if="!readonlyFormItem"
                                    :disabled="readonlyFormItem"
                                    type="button"
                                    class="btn btn-delete btn-sm min-w-auto"
                                    :title="$t(`${pageID}.basemap.buttons.clear.title`)"
                                    data-toggle="tooltip-city"
                                    data-placement="left"
                                    @click.prevent="setBasemap()">
                                    <i class="fas fa-xmark"></i>
                                </button>
                            </template>
                        </MaterialInput>
                    </div>
                </div>

                <buttons-footer
                    :enableButtons="!readonlyFormItem"
                    :cancelTitle="cancelTitle"
                    :submitTitle="submitTitle"
                    :isDisabled="isDisabled"
                    @save="onBeforeSaveItem"
                    @cancel="handleBack"
                >
                </buttons-footer>
            </form>

            <BasemapModal
                :panelID="pageID"
                :basemapType="basemapType"
                :basemapUrl="resourcesUrl"
                :basemapItems="galleryItems"
                :readonlyFormItem="readonlyFormItem"
                keyChilds="map_services"
                keyGroup="map_service_group_id"
                :show="showBasemapModal"
                @select="onSelectBasemap"
                @close="onCloseBasemapModal"
            />
        </div>
    </div>
</template>

<script>
    import CkEditorConfigMixin from '@/app/shared/mixins/ckeditor/BaseCkEditorConfigMixin';
    import GeneralMixin from '../mixins/GeneralMixin';
    import {BasemapType} from './mixins/Constants';
    import {capitalizeFirstLetter, isURL} from '@config/utils';

  	export default {
        name: 'DefaultLayersList',
  		mixins: [
            GeneralMixin,
            CkEditorConfigMixin
        ],
        components: {
            UploadSingleImage: () => import(/* webpackChunkName: "upload-single-image" */ '@/components/form/UploadSingleImage'),
            HelpSpan: () => import(/* webpackChunkName: "help-span" */ '@/components/form/HelpSpan'),
            BasemapModal: () => import(/* webpackChunkName: "basemap-modal" */ './elements/BasemapModal'),
        },
        props: {
            panelID: {
                type: String,
                default: 'default_layers',
            },
        },
    	data() {
      		return {
      			pageID: this.panelID,
        		form: {
                    id: null,
                    name: null,
                    tooltip: null,
                    behavior: null,
                    attribution: '',
                    img: null,
                    apikey: null,

                    param_transparent: true,
                    param_tiled: true,
                    param_xyz: true,
                    param_style: null,
                    param_format: null,
                    param_transition: null,
                    param_interpolate: null,
                    request_encoding: null,

                    resource: null,
                    ogc_remote_service_resource_id: null,
                    map_service_id: null,
                    map_service: null,
                    minzoom: null,
                    maxzoom: null,
                    opacity: 1,
                    order: 1,
                    visible: true,
                    status: 1,
	            },
                lists: {
                    behaviors: [],
                    map_service_groups: [],
                },
                basemapType: null,
                showBasemapModal: false,
      		}
    	},
        mounted() {
            this.loadLists();
        },
        computed: {
            resourcesUrl() {
                return this.url.getResources;
            },
            galleryItems() {
                return this.lists.map_service_groups;
            },
            layer() {
                return this.form.map_service || this.form.resource;
            },
            layerName() {
                return this.layer ? (this.layer.fullname || this.layer.name) : null;
            },
            isOverlay() {
                return this.form.behavior == 'overlay';
            },
            isBase() {
                return !this.isOverlay;
            },
        },
		methods: {
            onBeforeSaveItem: function() {
                this.saveItemOldWay(false, ['map_service', 'resource']);
            },
            onShowBasemapGallery: function() {
                this.onShowBasemapModal(BasemapType.GALLERY);
            },
            onShowBasemapOgc: function() {
                this.onShowBasemapModal(BasemapType.OGC);
            },
            onSelectBasemap: function(params) {
                let {type, id, group_id, item} = params;
                this[`setBasemapFrom${capitalizeFirstLetter(type)}`](id, item);
                this.setBasemapModal(false);
            },
            onShowBasemapModal: function(type) {
                this.basemapType = type;
                this.setBasemapModal(true);
            },
            onCloseBasemapModal: function(data) {
                this.basemapType = null;
                this.setBasemapModal(false);
            },
            setBasemapModal: function(flag) {
                this.showBasemapModal = flag;
            },
            setBasemapFromGallery: function(id, item) {
                this.setBasemap(id, null, item);
                this.$root.$emit('openConfirmation', {
                    id: id,
                    data: this.layer,
                    text: this.$t(`${this.pageID}.msg.confirm.use_image_layer`),
                    callback: (id, data) => {
                        let imgUrl = data?.image;
                        if(imgUrl && isURL(imgUrl)) {
                            fetch(imgUrl)
                            .then(res => res.blob()) // Gets the response and returns it as a blob
                            .then(blob => {
                                const file = new File([blob], imgUrl.split('/').pop(), {type: blob.type});
                                this.form.img = file;
                            });
                        }
                    }
                });
            },
            setBasemapFromOgc: function(id, item) {
                this.setBasemap(null, id, item);
            },
            setBasemap: function(service_id = null, ogc_id = null, item = null) {
                this.form.map_service_id = service_id;
                this.form.ogc_remote_service_resource_id = ogc_id;
                this.form.resource = null;
                this.form.map_service = null;
                let newAttribution = '';
                if(service_id) {
                    newAttribution = item?.params?.attributions ?? '';
                    this.$set(this.form, 'map_service', item);
                }
                if(ogc_id) {
                    newAttribution = item?.attribution ?? '';
                    this.$set(this.form, 'resource', item);
                }
                this.form.attribution = (this.form.attribution ?? '') + newAttribution;
            }
        },
        watch: {

        }
  	}
</script>

<style lang="sass" scoped>
.image-container {
    min-height: 150px;
}
</style>